// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Kq2sf","title":"Info_title__9g-xJ","links":"Info_links__2niVf","link":"Info_link__1PWbK","logo":"Info_logo__3LN59"};